// extracted by mini-css-extract-plugin
export default {"left":"LeftHeader_left__d7xS9","logo":"LeftHeader_logo__Utxmy","desktopOnly":"LeftHeader_desktopOnly__yQEiT"};